import { render, staticRenderFns } from "./DoctorAssistantRelationList.vue?vue&type=template&id=64e8f714&scoped=true&"
import script from "./DoctorAssistantRelationList.vue?vue&type=script&lang=js&"
export * from "./DoctorAssistantRelationList.vue?vue&type=script&lang=js&"
import style0 from "./DoctorAssistantRelationList.vue?vue&type=style&index=0&id=64e8f714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e8f714",
  null
  
)

export default component.exports